import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser,faCircleUser } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';

export const Navbar = () => {
  const { t } = useTranslation(['common']);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginuser = useSelector((state) => state.admin);
  const user = JSON.parse(localStorage.getItem('user'));
  console.log(loginuser);
  localStorage.setItem('userId', JSON.stringify(user.userId));
  console.log(user.userId)
  const logOutHandler = () => {
    console.log("Log out Handler Call")
    let keysToRemove = ["user", "admAdId","getUserId","eventId","bannerId","productCatId","orgAdId","causeId","causeCategoryId","kioskId",
    "ethnicId","userId","donorIdforRecurring","donorId","merchantId"];
      for (let key of keysToRemove) {
        localStorage.removeItem(key);
      }
    navigate('/adminlogin');
    window.location.reload();
  };
  //* Drop Down
  const items = [
    {
      label: (
        <a rel='noopener noreferrer' href={`/profile/edit`}>
        Profile  
        </a>
      ),
      key: '0',
    },
    {
      label: (
        <a target='_blank' onClick={logOutHandler}>
         Sign Out
        </a>
      ),
      key: '1',
    },
    // {
    //   label: (
    //     <a target='_blank' rel='noopener noreferrer' href='https://www.aliyun.com'>
    //      Edit Profile
    //     </a>
    //   ),
    //   key: '1',
    // },
    // {
    //   type: 'divider',
    // },
    // {
    //   label: '3rd menu item（disabled）',
    //   key: '3',
    //   disabled: true,
    // },
  ];
  //* Dropdown
  return (
    <nav class='color4' style={{height:"70px"}}>
      {/* <div class='d-flex justify-content-between'>
        <div class='mr-auto'>
          <img src='/logo.png' style={{ height: '57px', padding: '3px', marginTop:"5px" }} alt='Logo Image' />
        </div>
        <div class='p-2 mt-3 mr-3 fw-bold text-white'>
          Test
        </div>
        <div class=' p-2 mt-3 mr-3 fw-bold text-white'>
          {t('Hi')}! {user ? user.name : ' '}{' '}
        </div>
        <Dropdown className="mt-3 mr-3 text-white "
          menu={{
            items,
          }}
        >
          <a onClick={(e) => e.preventDefault()}>
            <Space>
            <FontAwesomeIcon   className='mr-2 text-white fa-2xl' icon={faCircleUser} />
              <DownOutlined style={{width:"40px"}}/>
            </Space>
          </a>
        </Dropdown>
      </div> */}
      <div class="d-flex justify-content-between">
  <div class="p-2">  <img src='/logo.png' style={{ height: '57px', padding: '2px', marginTop:"0px" }} alt='Logo Image' /></div>
  <div class="p-2 text-white fs-2">Admin Portal</div>
  <div class="p-0 pt-2"><div class=' p-2 ml-3 fw-bold text-white'>
          {t('Hi')}! {user ? user.name : ' '}{' '}
       
        <Dropdown className="mt-3 mr-3 text-white "
          menu={{
            items,
          }}
        >
          <a onClick={(e) => e.preventDefault()}>
            <Space>
            <FontAwesomeIcon   className='mr-2 text-white fa-2xl' icon={faCircleUser} />
              <DownOutlined style={{width:"40px"}}/>
            </Space>
          </a>
        </Dropdown></div>
        </div>
</div>
    </nav>
  );
};
export default Navbar;
